import { createSelector } from 'reselect';

const stateRegistrationSelector = (state) => state.registration;

export const registrationSelector = createSelector(
    [stateRegistrationSelector],
    (registration) => {
        return { ...registration };
    }
);